
<template>
  <div ref="filterSaveModalRef">
    <a-modal v-model:visible="innerVisible" width="420px" :title="modalTitle" :maskClosable="false" :centered="true" :confirmLoading="loading" @ok="handleSubmit" @cancel="handleCancel" :destroyOnClose="true">
      <div class="card">
        <div v-if="type == 'add'" class="card-tips">将当前的筛选条件保存为视图</div>
        <a-form ref="formRef" :model="formState" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
          <a-row>
            <a-col :span="24">
              <a-form-item label="视图名称" name="name">
                <a-input v-model:value.trim="formState.name" :maxlength="10" class="form-item-input" placeholder="请输入视图名称，不超过10个字" autocomplete="off" allowClear/>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </a-modal>
  </div>
</template>

<script lang="ts" setup>
import { ref, computed, onMounted, watch } from 'vue'
import {
  saveMenuViewsApi,
  updateMenuViewsApi
} from "/@/components/ViewMenu/src/api";
import { useMessage } from '/@/hooks/web/useMessage';
import { emitMenuViewUpdateChange } from '/@/components/ViewMenu/src/config';

const emit = defineEmits(['confirm', 'cancel'])
const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  type: {
    type: String,
    default: 'add' // add: 新增, rename: 编辑
  },
  viewData: {
    type: Object,
    default: () => {}
  }
})

const innerVisible = ref(false)

watch(() => props.visible,() => {
    innerVisible.value = props.visible
  },{immediate: true}
);


const { createMessage } = useMessage();

const modalTitle = computed(() => {
  return props.type == 'rename' ? '重命名视图' : '保存视图' 
})


const labelCol = {style: {width: '100px'}}
// 表单宽度
const wrapperCol = {style: {width: 'calc(100% - 100px)'}}
const formRef = ref()


const formState = ref({
  name: '', // 姓名
})

const rules = {
  name: [
    {required: true, message: '请输入视图名称', trigger: ['blur', 'change']}, 
  ]
}

const loading = ref(false)
// 保存视图
const saveViewHandel = () => {
  const params = {
    ...props.viewData,
    name: formState.value.name,
  }
  loading.value = true
  saveMenuViewsApi(params).then(res => {
    createMessage.success('视图保存成功');
    handelSubmitSuccess({type: 'add', data: res})
  }).finally(() => {
    loading.value = false
  })
}
// 重命名视图
const updateMenuViews = () => {
  const params = {
    ...props.viewData,
    name: formState.value.name,
  }
  loading.value = true
  updateMenuViewsApi(params).then(res => {
    createMessage.success('视图重命名成功');
    handelSubmitSuccess({type: 'update', data: params})
  }).finally(() => {
    loading.value = false
  })
}
// 提交成功 给onMenuViewUpdateChange监听发送消息
const handelSubmitSuccess = (data) => {
  emitMenuViewUpdateChange(data)
  innerVisible.value = false
  emit('confirm')
}

//确定选择事件
const handleSubmit = () => {
  formRef.value.validate().then(() => {
    if (props.type == 'rename') {
      updateMenuViews()
    } else {
      saveViewHandel()
    }
  }).catch((err) => {})
}
const handleCancel = () => {
  formRef.value.resetFields()
  innerVisible.value = false
  emit('cancel')
}

onMounted(() => {
  formState.value.name = props.viewData.name
})
</script>

<style lang="less" scoped>
@formInputWidth: 280px;
.form-item-input {
  width: @formInputWidth;
}

.form-item-input-row {
  width: calc(50% + 50px + @formInputWidth);
}

.card {
  padding: 24px 16px;
}
.card-tips {
  color: #767676;
  margin-bottom: 12px;
}

</style>
